import { latexTillTal } from "./latex-till-tal";

// KaTeX renders every formula twice: a MathML tree (semantic, carries the
// source LaTeX in <annotation>) and an HTML tree (visual, aria-hidden). Reading
// element.textContent straight off the page would therefore say every formula
// twice, in unreadable pieces. We replace the whole .katex node with spoken
// Swedish instead, which also means MDX content (rehype-katex) and uppgiftstext
// (InlineMath's katex.renderToString) go through exactly the same code path.
export function taltextFran(el: HTMLElement): string {
  const klon = el.cloneNode(true) as HTMLElement;

  // Buttons, uppgiftsnummer, badges — chrome that should never be spoken.
  klon.querySelectorAll("[data-uppl-ignore]").forEach((n) => n.remove());

  klon.querySelectorAll(".katex").forEach((n) => {
    const tex =
      n.querySelector('annotation[encoding="application/x-tex"]')?.textContent ?? "";
    n.replaceWith(document.createTextNode(` ${latexTillTal(tex)} `));
  });

  // Defensive: a KaTeX fragment rendered without MathML would still carry the
  // aria-hidden visual copy. Dropping it is always safe — it is a duplicate.
  klon.querySelectorAll(".katex-html").forEach((n) => n.remove());

  return normaliseraTal(klon.textContent ?? "");
}

export function normaliseraTal(ratext: string): string {
  return ratext
    .replace(/\s+/g, " ")
    .replace(/\s+([,.:;!?])/g, "$1")
    .trim();
}
